import React from "react";
import MediaRenderer from "./MediaRenderer";
import type { ChatMessage } from "../annotations/WhatsAppAnnotations";

interface Props {
  msg: ChatMessage;
}

// Helper function to check if message contains only emojis
const containsOnlyEmoji = (text: string) => {
  if (!text) {return false;}
  const emojiRegex = /^(?:\p{Emoji_Presentation}|\p{Emoji}\uFE0F|\p{Emoji_Modifier_Base})(?:\p{Emoji_Modifier})*$/gu;
  const matched = text.match(emojiRegex);
  return matched && matched.join('') === text;
};

const Messages: React.FC<Props> = ({ msg }) => {
  const isOutgoing = msg.type === "outgoing";
  const isMedia = msg.message.type === "media";
  const media = msg.message.media || [];
  const isImage = media[0]?.mediaType?.startsWith("image/");
  const hasCaption = media[0]?.mediaCaption;

  const messageText = msg.message.message;
  const isEmojiOnly = !isMedia && typeof messageText === "string" && containsOnlyEmoji(messageText);

  return (
    <div className={`${isOutgoing ? "text-end" : "text-start"} marginTopPoint8`}>
      <div className={`message ${msg.type}`}>
        <div className="d-flex align-items-end position-relative">
          <span
            className={`marginRightPoint5 message-content ${
              isEmojiOnly ? "emoji-only" : ""
            }`}
          >
            {isMedia ? (
              <MediaRenderer mediaItems={media} />
            ) : (
              messageText
            )}
          </span>

          <div
            className={`message-time ${
              isMedia && isImage
                ? hasCaption
                  ? "message-time-message-position position-absolute"
                  : "message-time-position position-absolute"
                : ""
            }`}
          >
            {msg.time}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Messages;
